import { render } from "./EligibilityReminder.vue?vue&type=template&id=21195f88&scoped=true"
import script from "./EligibilityReminder.vue?vue&type=script&lang=js"
export * from "./EligibilityReminder.vue?vue&type=script&lang=js"

import "./EligibilityReminder.vue?vue&type=style&index=0&id=21195f88&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21195f88"]])

export default __exports__